import { useState } from "react";

function useScrollToTarget(initialTargets) {
    const [targets, setTargets] = useState(initialTargets);

    const scrollToTarget = (targetId) => {
        const targetIndex = targets.findIndex(
            (target) => target.id === targetId
        );
        if (targetIndex !== -1) {
            const target = targets[targetIndex].ref;
            if (target.current) {
                target.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }
    };

    const addTarget = (id, ref) => {
        setTargets((prevTargets) => [...prevTargets, { id, ref }]);
    };

    const removeTarget = (id) => {
        setTargets((prevTargets) =>
            prevTargets.filter((target) => target.id !== id)
        );
    };

    return { addTarget, removeTarget, scrollToTarget };
}

export default useScrollToTarget;
